import { Col } from '@amzn/stencil-react-components/layout';

/**
 * Horizontal divider line using Stencil's container border token.
 * Use between list items, card sections, or any repeated row content.
 */
export function Divider() {
  return (
    <Col
      css={{
        borderBottom: '1px solid var(--st-dt-color-border-container-default)',
      }}
    />
  );
}
